import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SelfServeNodeLevels } from "../types";
import { buildNodeLevelPropName } from "./buildNodeLevelPropName";
import { clearCurrentNodeLevelAndAboveFromLocalStorage } from "./localStorage";
export var resetCurrentNodeLevelStateAndAbove = function resetCurrentNodeLevelStateAndAbove(_ref) {
  var level = _ref.level,
    setSelfServeContextStore = _ref.setSelfServeContextStore;
  var resetNodes = {};
  for (var levelAbove = level; levelAbove <= SelfServeNodeLevels.length; levelAbove++) {
    var nodeLevelProp = buildNodeLevelPropName(levelAbove);
    resetNodes = _objectSpread(_objectSpread({}, resetNodes), {}, _defineProperty({}, nodeLevelProp, undefined));
  }
  setSelfServeContextStore(resetNodes);
  clearCurrentNodeLevelAndAboveFromLocalStorage(level);
};